import { firebaseTimestamp, TimeStamp } from './timestamp';
import { DocumentReference } from '@angular/fire/firestore';

export interface Story {
  id?: string;
  author?: { name: string, image?: string };
  categories?: string[];
  tags?: string[];
  title?: string;
  byline?: string;
  image?: string;
  slug?: string;
  content?: string;
  readTime?: number;
  created?: firebaseTimestamp;
  updated?: firebaseTimestamp;
  published?: firebaseTimestamp;
  featured?: boolean;
  roles?: { [key: string]: "owner" | "writer" | "reader" | "commenter" };
  type: StoryType;
  status: StoryStatus;
  problemStatus?: 'open' | 'resolved';
  allowComments?: boolean;
  visibility?: 'public' | 'private';
  user?: DocumentReference
}
export type StoryStatus = 'draft' | 'published' | 'pending';
export type StoryType = 'article' | 'blog' | 'snippet' | 'problem';
export interface Comment {
  parent?: DocumentReference;
  author?: { name: string, image?: string };
  content?: string;
  created?: firebaseTimestamp;
  updated?: firebaseTimestamp;
  user?: DocumentReference;
}
export const dummyStory: Story = {
  title: '',
  content: '',
  visibility: 'public',
  allowComments: true,
  type: 'article',
  status: 'draft'
}
export interface readStory extends Story {
  created: TimeStamp;
  updated: TimeStamp;
}

export interface readComment extends Comment {
  created: TimeStamp;
  updated: TimeStamp;
}
